import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-icustomer-card-preview',
  templateUrl: './icustomer-card-preview.component.html',
  styleUrls: ['./icustomer-card-preview.component.scss']
})
export class IcustomerCardPreviewComponent implements OnInit {
  old_layout_data: any;
  new_layout_data: any;
  is_new_layout_selected = true;
  current_report_option = 'Old Layout';
  constructor(public dialogRef: MatDialogRef<IcustomerCardPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private domSanitizer: DomSanitizer) {
    console.log(data);
    this.new_layout_data = data['data']['new_layout'];
    this.new_layout_data['pdf'] = this.domSanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['data']['new_layout']['pdf']);
    this.old_layout_data = data['data']['old_layout'];
    this.old_layout_data['pdf'] = this.domSanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['data']['old_layout']['pdf']);

  }

  reportChangeOptionCliked() {
    this.is_new_layout_selected = !this.is_new_layout_selected;
    if (this.is_new_layout_selected) {
      this.current_report_option = 'Old Layout';
    } else {
      this.current_report_option = 'New Layout';
    }
  }

  closeComponent() {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
